import BOTTOM from './BOTTOM.png';
import TOP from './TOP.png';

export default { BOTTOM, TOP }